module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pgInner adsEdit"
  }, [_c('div', {
    staticClass: "headBar"
  }, [_vm._v("新建选址")]), _vm._v(" "), _c('div', {
    staticClass: "pgbody",
    style: ('height:' + _vm.pageH + 'px;')
  }, [_c('el-scrollbar', {
    ref: "scroller1",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    attrs: {
      "model": _vm.params1,
      "rules": _vm.rules,
      "inline-message": "true",
      "show-message": false
    }
  }, [_c('div', {
    staticClass: "tabContent"
  }, [_c('div', {
    staticClass: "text-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_vm._v("分类")]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('el-form-item', [_c('dic-select', {
    attrs: {
      "code": "bgxzfl",
      "selectId": _vm.params1.officeLocationTypeId,
      "paramsKey": "officeLocationType",
      "plaText": "分类"
    },
    on: {
      "selectChange": _vm.selectChange
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_vm._v("楼盘名称")]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('el-form-item', [_c('el-input', {
    staticClass: "inpText",
    attrs: {
      "size": "medium",
      "placeholder": ""
    },
    model: {
      value: (_vm.params1.title),
      callback: function($$v) {
        _vm.$set(_vm.params1, "title", $$v)
      },
      expression: "params1.title"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_vm._v("位置信息")]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('el-form-item', [_c('ads-select', {
    attrs: {
      "adsList": _vm.adsStore,
      "selectType": "1"
    },
    on: {
      "selected": _vm.mapChange
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_vm._v("地铁信息")]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('el-form-item', [_c('dic-select', {
    attrs: {
      "code": "dt",
      "selectId": _vm.params2.subwayLineId,
      "paramsKey": "subwayLine",
      "plaText": "地铁"
    },
    on: {
      "selectChange": _vm.selectChange
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "size": "medium",
      "placeholder": "站点名称"
    },
    model: {
      value: (_vm.params2.subwayStation),
      callback: function($$v) {
        _vm.$set(_vm.params2, "subwayStation", $$v)
      },
      expression: "params2.subwayStation"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "size": "medium",
      "placeholder": "步行多少米"
    },
    model: {
      value: (_vm.params2.distance),
      callback: function($$v) {
        _vm.$set(_vm.params2, "distance", $$v)
      },
      expression: "params2.distance"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_vm._v("租金")]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('div', {}, [_c('el-form-item', [_c('el-input-number', {
    attrs: {
      "size": "medium",
      "step": 0.01,
      "precision": 2
    },
    model: {
      value: (_vm.params2.rentBegin),
      callback: function($$v) {
        _vm.$set(_vm.params2, "rentBegin", $$v)
      },
      expression: "params2.rentBegin"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "midspan"
  }, [_vm._v("—")]), _vm._v(" "), _c('el-form-item', [_c('el-input-number', {
    attrs: {
      "size": "medium",
      "step": 0.01,
      "precision": 2
    },
    model: {
      value: (_vm.params2.rentEnd),
      callback: function($$v) {
        _vm.$set(_vm.params2, "rentEnd", $$v)
      },
      expression: "params2.rentEnd"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v("\n                              元/㎡/天\n                           ")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "text-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_vm._v("商圈")]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('el-form-item', [_c('el-input', {
    staticClass: "inpText",
    attrs: {
      "size": "medium",
      "placeholder": "请输入楼盘所在商圈 例：海淀 - 中关村"
    },
    model: {
      value: (_vm.params1.officeArea),
      callback: function($$v) {
        _vm.$set(_vm.params1, "officeArea", $$v)
      },
      expression: "params1.officeArea"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_vm._v("面积")]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('div', {}, [_c('el-form-item', [_c('el-input-number', {
    attrs: {
      "size": "medium"
    },
    model: {
      value: (_vm.params1.area1),
      callback: function($$v) {
        _vm.$set(_vm.params1, "area1", $$v)
      },
      expression: "params1.area1"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "midspan"
  }, [_vm._v("—")]), _vm._v(" "), _c('el-form-item', [_c('el-input-number', {
    attrs: {
      "size": "medium"
    },
    model: {
      value: (_vm.params1.area2),
      callback: function($$v) {
        _vm.$set(_vm.params1, "area2", $$v)
      },
      expression: "params1.area2"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v("\n                                 ㎡\n                           ")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "text-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_vm._v("在租")]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('el-form-item', [_c('el-input-number', {
    attrs: {
      "size": "medium",
      "precision": 0
    },
    model: {
      value: (_vm.params2.onRent),
      callback: function($$v) {
        _vm.$set(_vm.params2, "onRent", $$v)
      },
      expression: "params2.onRent"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tips"
  }, [_vm._v("\n                               套\n                         ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-block textarea clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_vm._v("内容")]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5,
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.params1.content),
      callback: function($$v) {
        _vm.$set(_vm.params1, "content", $$v)
      },
      expression: "params1.content"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_vm._v("联系人")]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('el-form-item', [_c('el-input', {
    staticClass: "inpText",
    attrs: {
      "size": "medium",
      "placeholder": "请输入活动标题"
    },
    model: {
      value: (_vm.params1.contactPerson),
      callback: function($$v) {
        _vm.$set(_vm.params1, "contactPerson", $$v)
      },
      expression: "params1.contactPerson"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_vm._v("联系电话")]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('el-form-item', [_c('el-input', {
    staticClass: "inpText",
    attrs: {
      "size": "medium",
      "placeholder": "请输入活动标题"
    },
    model: {
      value: (_vm.params1.contactPhone),
      callback: function($$v) {
        _vm.$set(_vm.params1, "contactPhone", $$v)
      },
      expression: "params1.contactPhone"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-block tag-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_vm._v("标签")]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('tag-select', {
    attrs: {
      "selectTags": _vm.params1.tagNames,
      "paramsKey": "tagNames"
    },
    on: {
      "selectChange": _vm.tagChange
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_vm._v("头部图")]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('imgs-upload', {
    attrs: {
      "files": _vm.params1.coverImage,
      "tips": "（375*200推荐）"
    },
    on: {
      "fileChange": _vm.imgChange
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "text-block radio-block clearfix"
  }, [_c('div', {
    staticClass: "bName"
  }, [_vm._v("审核")]), _vm._v(" "), _c('div', {
    staticClass: "bContent"
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.params1.status),
      callback: function($$v) {
        _vm.$set(_vm.params1, "status", $$v)
      },
      expression: "params1.status"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 3
    }
  }, [_vm._v("通过")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 4
    }
  }, [_vm._v("不通过")])], 1)], 1)])])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "pagefoot"
  }, [(_vm.pgState) ? _c('div', {
    staticClass: "loading"
  }, [(_vm.pgState == 1) ? _c('span', [_vm._v("初始化中...")]) : _vm._e(), _vm._v(" "), (_vm.pgState == 2) ? _c('span', [_vm._v("数据保存中...")]) : _vm._e(), _vm._v(" "), _c('i', {
    staticClass: "el-icon-loading"
  })]) : _c('div', [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.directSave
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "plain": "",
      "size": "small"
    },
    on: {
      "click": _vm.goReturn
    }
  }, [_vm._v("取消")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-4eef7793"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/Enterprise/message/adsEdit.vue
// module id = 1489
// module chunks = 1